import React, { useState } from "react";
import { Tabs } from "@material-tailwind/react";

import FlatList from "../../components/ProjectScreens/FlatList";
import ConfigDetails from "../../components/ProjectScreens/ConfigDetails";
import Notifications from "../../components/ProjectScreens/Notifications";
import { useProject } from "../../context/ProjectContext";
import UserDetails from "./UserDetails";
import Installments from "./Installments";
import Agreements from "./Agreements";

function UserPage() {
  const { project } = useProject(); // Access the project from context
  const [activeTab, setActiveTab] = useState("userdetails");

  const data = [
    {
      label: "User details",
      value: "userdetails",
      component: <UserDetails />, 
    },
    {
      label: "Payment Installments",
      value: "installments",
      component: <Installments  />, 
    },
    
    {
      label: "Agreements",
      value: "agreements",
      component: <Agreements />,
    },
  ];

  const handleTabChange = (value) => {
    console.log("Tab changed to:", value); // Log the tab change
    setActiveTab(value);
  };

  return (
    <div>
      <Tabs value={activeTab} onChange={handleTabChange} className="flex flex-col">
        <div className="flex space-x-4 border-b border-gray-300 justify-center">
          {data.map(({ label, value }) => (
            <div
              key={value}
              onClick={() => handleTabChange(value)}
              className={`cursor-pointer py-2 px-28 ${
                activeTab === value
                  ? "text-gray-900 border-b-2 border-indigo-600 font-semibold"
                  : "text-gray-600"
              }`}
            >
              {label}
            </div>
          ))}
        </div>
        <div className="p-4">
          {data.find((item) => item.value === activeTab)?.component || <p>Select a tab to view details.</p>}
        </div>
      </Tabs>
    </div>
  );
}

export default UserPage;
